import { render, staticRenderFns } from "./NStepper.vue?vue&type=template&id=2023bb58"
import script from "./NStepper.vue?vue&type=script&lang=js"
export * from "./NStepper.vue?vue&type=script&lang=js"
import style0 from "./NStepper.vue?vue&type=style&index=0&id=2023bb58&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports